import { useQuery } from '@tanstack/react-query'
import useAxiosPrivate from '../../api/hooks/useAxiosPrivate'

export const SUPPORT_UNREAD_COUNTER_QUERY_KEY = ['supportUnreadCounter']

const useUnreadSupportCounter = () => {
  const axiosPrivate = useAxiosPrivate()

  const { data } = useQuery({
    queryKey: SUPPORT_UNREAD_COUNTER_QUERY_KEY,
    queryFn: async () => {
      const response = await axiosPrivate.get(
        '/api/support-requests/unread/counter'
      )

      return Number((response.data as number[])[0] ?? 0)
    },
    retry: 0,
    refetchInterval: 60_000,
  })

  return { supportCounter: data ?? 0 } as const
}

export default useUnreadSupportCounter
